export interface MealInfo {
  mealOptionName: string;
  mealOptionIcon: string | null;
  mealOptionColor: string | null;
}

export interface MealStatusCardProps {
  meal: MealInfo | null;
}

/**
 * Returns white or dark text color based on background luminance for contrast compliance.
 */
function getContrastTextColor(hexColor: string): string {
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5 ? '#0f2d1f' : '#ffffff';
}

export function MealStatusCard({ meal }: MealStatusCardProps) {
  const hasColor = meal?.mealOptionColor ? /^#[0-9A-Fa-f]{6}$/.test(meal.mealOptionColor) : false;
  const bgColor = hasColor ? meal!.mealOptionColor! : '#fff';
  const textColor = hasColor ? getContrastTextColor(bgColor) : '#0f2d1f';
  const headerColor = hasColor ? textColor : '#1a6b3c';
  const borderColor = hasColor ? meal!.mealOptionColor! : '#e0e0e0';

  return (
    <div
      style={{
        backgroundColor: bgColor,
        border: `1px solid ${borderColor}`,
        borderRadius: '8px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        padding: '1.25rem',
      }}
    >
      <div
        style={{
          fontSize: '0.85rem',
          fontWeight: 600,
          color: headerColor,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          marginBottom: '0.75rem',
        }}
      >
        Meal Selection
      </div>

      {meal ? (
        <div
          style={{
            fontSize: '1rem',
            fontWeight: 600,
            color: textColor,
          }}
        >
          {meal.mealOptionIcon && (
            <span style={{ marginRight: '0.5rem', fontSize: '1.2rem' }}>
              {meal.mealOptionIcon}
            </span>
          )}
          {meal.mealOptionName}
        </div>
      ) : (
        <div>
          <div
            style={{
              fontSize: '0.95rem',
              color: '#c9a84c',
              fontWeight: 500,
            }}
          >
            Pending
          </div>
        </div>
      )}
    </div>
  );
}
